var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconLanguageTelugu = function SvgIconLanguageTelugu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    x: 1,
    y: 1,
    fill: "#FFF",
    stroke: "#D342C8",
    strokeWidth: 2,
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D342C8",
    d: "M64.5 47.1c0 9.18-8.82 16.5-22.2 16.5-13.38 0-22.2-7.32-22.2-16.5 0-5.76 4.62-10.14 10.62-10.14 5.94 0 10.08 3.72 10.08 9.3 0 5.22-4.02 8.04-7.86 8.04-.36 0-.72 0-1.02-.06l-.12.24c2.64 1.56 6.6 2.34 10.5 2.34 3.9 0 7.86-.78 10.5-2.34l-.12-.24c-.36.06-.66.06-1.02.06-3.84 0-7.86-2.82-7.86-8.04 0-5.58 4.14-9.3 10.08-9.3.72 0 1.44.06 2.16.18-.36-1.26-1.8-2.04-4.98-2.04h-6.48v-6.6h8.52c2.1 0 3-.9 3-2.28s-.9-2.28-3-2.28H22.8v-6.6h30.36c6.78 0 10.14 3.9 10.14 8.88 0 2.52-.84 4.74-2.58 6.36 1.68 1.74 2.58 4.02 2.58 6.72 0 .54-.06 1.5-.3 2.52.96 1.5 1.5 3.3 1.5 5.28zm-37.02-.36c0 1.62.96 3 2.94 3 1.92 0 3.12-1.44 3.12-3.12 0-1.86-1.14-2.94-2.82-2.94-2.04 0-3.24 1.44-3.24 3.06zm23.58-.12c0 1.68 1.2 3.12 3.12 3.12 1.98 0 2.94-1.38 2.94-3s-1.2-3.06-3.24-3.06c-1.68 0-2.82 1.08-2.82 2.94z"
  }))));
};
export default SvgIconLanguageTelugu;